import moment from 'moment'

import {
  DateQuestion,
  DropdownQuestion,
  PhoneQuestion,
  Question,
  Questions,
} from '../../classes/question'
import { GuarantorRelationships } from '../../data'

export const getWelcomeQuestions = (customQuestions: Questions): Questions => [
  new Question({
    label: 'patient-intake.welcome.guarantor-field-name',
    key: 'guarantorGivenName',
    autocomplete: 'given-name',
    required: true,
    flex: '50',
  }),

  new Question({
    label: 'patient-intake.welcome.guarantor-field-last-name',
    key: 'guarantorFamilyName',
    autocomplete: 'family-name',
    required: true,
    flex: '50',
  }),

  new PhoneQuestion({
    label: 'patient-intake.welcome.guarantor-field-phone-number',
    key: 'guarantorPhoneNumber',
    required: true,
    autocomplete: 'tel',
    flex: '33',
  }),

  new DropdownQuestion({
    label: 'patient-intake.welcome.guarantor-field-relationship',
    key: 'guarantorRelationship',
    options: GuarantorRelationships,
    required: true,
    flex: '33',
  }),

  new DateQuestion({
    label: 'patient-intake.welcome.guarantor-field-birthday',
    key: 'guarantorDOB',
    required: true,
    max: moment().subtract(1, 'days').format('YYYY-MM-DD'),
    flex: '33',
  }),
  ...customQuestions,
]
